import React from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

interface metaProps {
  title?: string
  description?: string
  storeId?: number
  canonical?: string
}

export default function Seo({
  title,
  description,
  storeId,
  canonical,
}: metaProps) {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
        ogp: allFile(filter: { name: { eq: "ogp" } }) {
          edges {
            node {
              publicURL
            }
          }
        }
        recruitOgp: allFile(filter: { name: { eq: "recruit_ogp" } }) {
          edges {
            node {
              publicURL
            }
          }
        }
        miyawakaOgp: allFile(filter: { name: { eq: "remoteworktown_ogp" } }) {
          edges {
            node {
              publicURL
            }
          }
        }
        favicon: allFile(filter: { name: { eq: "favicon" } }) {
          edges {
            node {
              publicURL
            }
          }
        }
        miyawakaFavicon: allFile(
          filter: { name: { eq: "remoteworktown_favicon" } }
        ) {
          edges {
            node {
              publicURL
            }
          }
        }
      }
    `
  )

  const metaTitle = title || data.site.siteMetadata.title
  const metaDescription = description || data.site.siteMetadata.description
  let ogpPath
  let siteUrl
  let favicon = data.favicon.edges[0].node.publicURL

  if (typeof location !== 'undefined') {
    const path = location.pathname
    if (path.indexOf('/recruit/newgraduate') !== -1) {
      ogpPath = data.recruitOgp.edges[0].node.publicURL
      siteUrl = data.site.siteMetadata.siteUrl + '/recruit/newgraduate'
    } else if (path.indexOf('/remoteworktown') !== -1) {
      ogpPath = data.miyawakaOgp.edges[0].node.publicURL
      siteUrl = data.site.siteMetadata.siteUrl + '/remoteworktown'
      favicon = data.miyawakaFavicon.edges[0].node.publicURL
    } else {
      ogpPath = data.ogp.edges[0].node.publicURL
      siteUrl = data.site.siteMetadata.siteUrl
    }
  }

  return (
    <Helmet
      htmlAttributes={{
        lang: 'ja',
      }}
      link={[
        {
          rel: 'icon',
          href: favicon,
        },
      ]}
      title={metaTitle}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: metaTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: 'og:url',
          content: siteUrl,
        },
        {
          property: 'og:image',
          content: data.site.siteMetadata.siteUrl + ogpPath,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:site`,
          content: data.site.siteMetadata.author || ``,
        },
        {
          name: `twitter:creator`,
          content: data.site.siteMetadata.author || ``,
        },
        {
          name: 'format-detection',
          content: 'telephone=no',
        },
      ]}
    >
      {/* Twitter / Instagramの埋め込みが動作する */}
      <script async src="https://www.instagram.com/embed.js"></script>
      <script async src="https://platform.twitter.com/widgets.js"></script>

      {storeId && (
        <script
          async
          src={`https://knowledgetags.yextpages.net/embed?key=PM4fIk-LjyM0QMBOV2Ky42vX6t0bgtmS_pa3wBDrHjjzQLTKizVLNhUazgQkqhz3&account_id=4874813418318405769&entity_id=${storeId}&locale=ja&v=20210504`}
          type="text/javascript"
        />
      )}
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  )
}
